import type { EdgeConfig, EdgeConfigWidget } from '@/edge/types';

const EMPTY_EDGE_CONFIG_WIDGET = {} as EdgeConfigWidget;

export const getEdgeConfigWidget = <
  ConfigWidgetId extends keyof Edge.AllWidgetsByKey,
  ConfigWidgetModel extends Edge.AllWidgetsByKey[ConfigWidgetId],
>(
  edgeConfig: EdgeConfig,
  widgetId: ConfigWidgetId,
): ConfigWidgetModel => {
  const widgetModel = edgeConfig?.widgets?.[widgetId] ?? EMPTY_EDGE_CONFIG_WIDGET;

  if (Object.keys(widgetModel).length === 0) {
    console.error(`[EdgeConfig widget] is empty, check the provided ${widgetId}`);
  }

  return widgetModel?.model as ConfigWidgetModel;
};
